import { Injectable } from '@angular/core';
import { Address } from '../models/address';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { UserService } from './user.service';
import { User } from '../micro-services/user/models/user';

@Injectable({
  providedIn: 'root'
})
export class AddressService {


  private addressSubject = new BehaviorSubject<Address[]>([]);
  addresses$ = this.addressSubject.asObservable();
  coach : User;

  constructor(private api: ApiProviderService,
    private userService: UserService
  ) {
    this.coach = userService.user
   }

  loadAddresses(): void {
    this.api.getAddressesByCoach(this.coach).subscribe(
      (addresses) => this.addressSubject.next(addresses),
      (error) => console.error('Failed to load addresses', error)
    );
  }

  createAddress(address: Address): Observable<Address> {
    address.coachId = this.coach.id;
    return this.api.createAddress(address).pipe(
      tap(newAddress => {
        const currentAddresses = this.addressSubject.value;
        this.addressSubject.next([...currentAddresses, newAddress]);
      })
    );
  }

  editAddress(address: Address): Observable<Address> {
    return this.api.editAddress(address).pipe(
      tap(updatedAddress => {
        const currentAddresses = this.addressSubject.value.map(addr =>
          addr.id === updatedAddress.id ? updatedAddress : addr
        );
        this.addressSubject.next(currentAddresses);
      })
    );
  }

  deleteAddress(address: Address): Observable<number> {
    return this.api.deleteAddress(address).pipe(
      tap(() => {
        const currentAddresses = this.addressSubject.value.filter(addr => addr.id !== address.id);
        this.addressSubject.next(currentAddresses);
      })
    );
  }
  
}
